export function titleCaseSchoolName(host) {
    const  schoolsThatDoNotFollowTitleCase = {
        'rbschool.edves.net': true,
        'efs.edves.net': true,
    }

    return schoolsThatDoNotFollowTitleCase?.[host] !== true
}